import type { ComponentProps } from 'react';
import { cn } from '@bill-alps/ui';

/**
 * The authenticated mobile shell owns the screen h1. Content headings return
 * at md, where the desktop shell has no route title of its own.
 */
export function PageHeading({ className, ...props }: ComponentProps<'h1'>) {
  return (
    <h1
      data-page-heading
      className={cn('hidden md:block', className)}
      {...props}
    />
  );
}

/** Keeps supporting copy while dropping the margin left by a hidden h1. */
export function PageHeadingDescription({
  className,
  ...props
}: ComponentProps<'p'>) {
  return (
    <p className={cn('text-muted-foreground md:mt-2', className)} {...props} />
  );
}
